import { Link } from "react-router-dom";

import moment from "moment";
import { Button, Icon } from "semantic-ui-react";

import { OpenAPI } from "simplydo/interfaces";

import { useAppSelector } from "store";
import util from "utils/utils";

import RowComponent from "components/lib/RowComponent";

type HomePollsProps = {
  polls: (OpenAPI.Schemas["Poll"] & { hasResponded: boolean })[];
};
const HomePolls = ({ polls }: HomePollsProps) => {
  const user = useAppSelector((state) => state.user);

  if (!polls?.length) return null;
  return (
    <RowComponent>
      <RowComponent.Fill>
        <RowComponent.Title>Polls</RowComponent.Title>
      </RowComponent.Fill>
      {polls.map((poll, index) => (
        <RowComponent.Cell
          index={index}
          key={poll._id}
          as={"a"}
          href={`/polls/${poll._id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon name="bolt" size="big" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: 5,
              marginRight: 5,
              position: "relative",
              top: -1,
            }}
          >
            <RowComponent.Title style={{ color: "#5d5d5d" }} block>
              {poll.name}
            </RowComponent.Title>
            {poll?.hasResponded && (
              <span style={{ color: "green" }}>
                <Icon name="check circle" />
                Completed
              </span>
            )}
            {poll?.deadline && (
              <span style={{ color: "orange" }}>
                <Icon name="time" />
                Closes {moment(poll.deadline).fromNow()}
              </span>
            )}
          </div>
        </RowComponent.Cell>
      ))}
    </RowComponent>
  );
};

export default HomePolls;
